require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-eisenstadt-und-umgebung-purbach-am-neusiedler-see.json") })
        }
      }, "path---betreuungseinrichtungen-eisenstadt-und-umgebung-purbach-am-neusiedler-see");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-eisenstadt-und-umgebung-purbach-am-neusiedler-see!./.cache/json/betreuungseinrichtungen-eisenstadt-und-umgebung-purbach-am-neusiedler-see.json
// module id = 868
// module chunks = 231608221292675